import { RSAA } from 'redux-api-middleware';
import { cached_fetch } from '../../../utils/cached';

export const FETCH_COUNTRY_SND_MAP_BY_ID_REQUEST =
  '@@map/FETCH_COUNTRY_SND_MAP_BY_ID_REQUEST';
export const FETCH_COUNTRY_SND_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_COUNTRY_SND_MAP_BY_ID_SUCCESS';
export const FETCH_COUNTRY_SND_MAP_BY_ID_FAILURE =
  '@@map/FETCH_COUNTRY_SND_MAP_BY_ID_FAILURE';

export const FETCH_SND_REGION_MAP_BY_ID_REQUEST =
  '@@map/FETCH_SND_REGION_MAP_BY_ID_REQUEST';
export const FETCH_SND_REGION_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_SND_REGION_MAP_BY_ID_SUCCESS';
export const FETCH_SND_REGION_MAP_BY_ID_FAILURE =
  '@@map/FETCH_SND_REGION_MAP_BY_ID_FAILURE';

export const FETCH_SND_AREA_MAP_BY_ID_REQUEST =
  '@@map/FETCH_SND_AREA_MAP_BY_ID_REQUEST';
export const FETCH_SND_AREA_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_SND_AREA_MAP_BY_ID_SUCCESS';
export const FETCH_SND_AREA_MAP_BY_ID_FAILURE =
  '@@map/FETCH_SND_AREA_MAP_BY_ID_FAILURE';

export const FETCH_SND_TERRITORY_MAP_BY_ID_REQUEST =
  '@@map/FETCH_SND_TERRITORY_MAP_BY_ID_REQUEST';
export const FETCH_SND_TERRITORY_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_SND_TERRITORY_MAP_BY_ID_SUCCESS';
export const FETCH_SND_TERRITORY_MAP_BY_ID_FAILURE =
  '@@map/FETCH_SND_TERRITORY_MAP_BY_ID_FAILURE';

export const FETCH_DISTRIBUTION_HOUSE_SUMMARY_REQUEST =
  '@@map/FETCH_DISTRIBUTION_HOUSE_SUMMARY_REQUEST';
export const FETCH_DISTRIBUTION_HOUSE_SUMMARY_SUCCESS =
  '@@map/FETCH_DISTRIBUTION_HOUSE_SUMMARY_SUCCESS';
export const FETCH_DISTRIBUTION_HOUSE_SUMMARY_FAILURE =
  '@@map/FETCH_DISTRIBUTION_HOUSE_SUMMARY_FAILURE';

export const FETCH_HIGH_BALANCE_AGENT_SUMMARY_REQUEST =
  '@@map/FETCH_HIGH_BALANCE_AGENT_SUMMARY_REQUEST';
export const FETCH_HIGH_BALANCE_AGENT_SUMMARY_SUCCESS =
  '@@map/FETCH_HIGH_BALANCE_AGENT_SUMMARY_SUCCESS';
export const FETCH_HIGH_BALANCE_AGENT_SUMMARY_FAILURE =
  '@@map/FETCH_HIGH_BALANCE_AGENT_SUMMARY_FAILURE';

export const FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_REQUEST =
  '@@map/FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_REQUEST';
export const FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_SUCCESS =
  '@@map/FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_SUCCESS';
export const FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_FAILURE =
  '@@map/FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_FAILURE';

export const FETCH_DH_STOCK_PROGRESS_SUMMARY_REQUEST =
  '@@map/FETCH_DH_STOCK_PROGRESS_SUMMARY_REQUEST';
export const FETCH_DH_STOCK_PROGRESS_SUMMARY_SUCCESS =
  '@@map/FETCH_DH_STOCK_PROGRESS_SUMMARY_SUCCESS';
export const FETCH_DH_STOCK_PROGRESS_SUMMARY_FAILURE =
  '@@map/FETCH_DH_STOCK_PROGRESS_SUMMARY_FAILURE';

export const FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_REQUEST =
  '@@map/FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_REQUEST';
export const FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_SUCCESS =
  '@@map/FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_SUCCESS';
export const FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_FAILURE =
  '@@map/FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_FAILURE';

export const FETCH_AGENT_WITH_TRANSACTION_SUMMARY_REQUEST =
  '@@map/FETCH_AGENT_WITH_TRANSACTION_SUMMARY_REQUEST';
export const FETCH_AGENT_WITH_TRANSACTION_SUMMARY_SUCCESS =
  '@@map/FETCH_AGENT_WITH_TRANSACTION_SUMMARY_SUCCESS';
export const FETCH_AGENT_WITH_TRANSACTION_SUMMARY_FAILURE =
  '@@map/FETCH_AGENT_WITH_TRANSACTION_SUMMARY_FAILURE';

export const FETCH_LEADING_AGENT_SUMMARY_REQUEST =
  '@@map/FETCH_LEADING_AGENT_SUMMARY_REQUEST';
export const FETCH_LEADING_AGENT_SUMMARY_SUCCESS =
  '@@map/FETCH_LEADING_AGENT_SUMMARY_SUCCESS';
export const FETCH_LEADING_AGENT_SUMMARY_FAILURE =
  '@@map/FETCH_LEADING_AGENT_SUMMARY_FAILURE';

export const FETCH_LEADING_AGENT_TPV_SUMMARY_REQUEST =
  '@@map/FETCH_LEADING_AGENT_TPV_SUMMARY_REQUEST';
export const FETCH_LEADING_AGENT_TPV_SUMMARY_SUCCESS =
  '@@map/FETCH_LEADING_AGENT_TPV_SUMMARY_SUCCESS';
export const FETCH_LEADING_AGENT_TPV_SUMMARY_FAILURE =
  '@@map/FETCH_LEADING_AGENT_TPV_SUMMARY_FAILURE';

export const FETCH_LEADING_AGENT_CATEGORY_SUMMARY_REQUEST =
  '@@map/FETCH_LEADING_AGENT_CATEGORY_SUMMARY_REQUEST';
export const FETCH_LEADING_AGENT_CATEGORY_SUMMARY_SUCCESS =
  '@@map/FETCH_LEADING_AGENT_CATEGORY_SUMMARY_SUCCESS';
export const FETCH_LEADING_AGENT_CATEGORY_SUMMARY_FAILURE =
  '@@map/FETCH_LEADING_AGENT_CATEGORY_SUMMARY_FAILURE';

export const FETCH_MILKING_AGENT_SUMMARY_REQUEST =
  '@@map/FETCH_MILKING_AGENT_SUMMARY_REQUEST';
export const FETCH_MILKING_AGENT_SUMMARY_SUCCESS =
  '@@map/FETCH_MILKING_AGENT_SUMMARY_SUCCESS';
export const FETCH_MILKING_AGENT_SUMMARY_FAILURE =
  '@@map/FETCH_MILKING_AGENT_SUMMARY_FAILURE';

export const FETCH_ACTIVE_AGENT_SUMMARY_REQUEST =
  '@@map/FETCH_ACTIVE_AGENT_SUMMARY_REQUEST';
export const FETCH_ACTIVE_AGENT_SUMMARY_SUCCESS =
  '@@map/FETCH_ACTIVE_AGENT_SUMMARY_SUCCESS';
export const FETCH_ACTIVE_AGENT_SUMMARY_FAILURE =
  '@@map/FETCH_ACTIVE_AGENT_SUMMARY_FAILURE';

export const FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_REQUEST =
  '@@map/FETCH_ACTIVE_WITHOUT_disbursement_AGENT_SUMMARY_REQUEST';
export const FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_SUCCESS =
  '@@map/FETCH_ACTIVE_WITHOUT_disbursement_AGENT_SUMMARY_SUCCESS';
export const FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_FAILURE =
  '@@map/FETCH_ACTIVE_WITHOUT_disbursement_AGENT_SUMMARY_FAILURE';

export const FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_REQUEST =
  '@@map/FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_REQUEST';
export const FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_SUCCESS =
  '@@map/FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_SUCCESS';
export const FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_FAILURE =
  '@@map/FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_FAILURE';

export const FETCH_TERRITORY_DISTRIBUTION_HOUSES_REQUEST =
  '@@map/FETCH_TERRITORY_DISTRIBUTION_HOUSES_REQUEST';
export const FETCH_TERRITORY_DISTRIBUTION_HOUSES_SUCCESS =
  '@@map/FETCH_TERRITORY_DISTRIBUTION_HOUSES_SUCCESS';
export const FETCH_TERRITORY_DISTRIBUTION_HOUSES_FAILURE =
  '@@map/FETCH_TERRITORY_DISTRIBUTION_HOUSES_FAILURE';

export const FETCH_TERRITORY_HIGH_BALANCE_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_HIGH_BALANCE_AGENTS_REQUEST';
export const FETCH_TERRITORY_HIGH_BALANCE_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_HIGH_BALANCE_AGENTS_SUCCESS';
export const FETCH_TERRITORY_HIGH_BALANCE_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_HIGH_BALANCE_AGENTS_FAILURE';

export const FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_REQUEST =
  '@@map/FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_REQUEST';
export const FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_SUCCESS =
  '@@map/FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_SUCCESS';
export const FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_FAILURE =
  '@@map/FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_FAILURE';

export const FETCH_TERRITORY_DH_STOCK_PROGRESS_REQUEST =
  '@@map/FETCH_TERRITORY_DH_STOCK_PROGRESS_REQUEST';
export const FETCH_TERRITORY_DH_STOCK_PROGRESS_SUCCESS =
  '@@map/FETCH_TERRITORY_DH_STOCK_PROGRESS_SUCCESS';
export const FETCH_TERRITORY_DH_STOCK_PROGRESS_FAILURE =
  '@@map/FETCH_TERRITORY_DH_STOCK_PROGRESS_FAILURE';

export const FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_REQUEST =
  '@@map/FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_REQUEST';
export const FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_SUCCESS =
  '@@map/FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_SUCCESS';
export const FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_FAILURE =
  '@@map/FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_FAILURE';

export const FETCH_TERRITORY_ACTIVE_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_REQUEST';
export const FETCH_TERRITORY_ACTIVE_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_SUCCESS';
export const FETCH_TERRITORY_ACTIVE_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_FAILURE';

export const FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_REQUEST =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_REQUEST';
export const FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_SUCCESS =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_SUCCESS';
export const FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_FAILURE =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_FAILURE';

export const FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_REQUEST =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_REQUEST';
export const FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_SUCCESS =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_SUCCESS';
export const FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_FAILURE =
  '@@map/FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_FAILURE';

export const FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_REQUEST =
  '@@map/FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_REQUEST';
export const FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_SUCCESS =
  '@@map/FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_SUCCESS';
export const FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_FAILURE =
  '@@map/FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_FAILURE';

export const FETCH_TERRITORY_LEADING_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_LEADING_AGENTS_REQUEST';
export const FETCH_TERRITORY_LEADING_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_LEADING_AGENTS_SUCCESS';
export const FETCH_TERRITORY_LEADING_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_LEADING_AGENTS_FAILURE';

export const FETCH_TERRITORY_LEADING_AGENTS_TPV_REQUEST =
  '@@map/FETCH_TERRITORY_LEADING_AGENTS_TPV_REQUEST';
export const FETCH_TERRITORY_LEADING_AGENTS_TPV_SUCCESS =
  '@@map/FETCH_TERRITORY_LEADING_AGENTS_TPV_SUCCESS';
export const FETCH_TERRITORY_LEADING_AGENTS_TPV_FAILURE =
  '@@map/FETCH_TERRITORY_LEADING_AGENTS_TPV_FAILURE';

export const FETCH_TERRITORY_LEADING_GOLD_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_LEADING_GOLD_AGENTS_REQUEST';
export const FETCH_TERRITORY_LEADING_GOLD_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_LEADING_GOLD_AGENTS_SUCCESS';
export const FETCH_TERRITORY_LEADING_GOLD_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_LEADING_GOLD_AGENTS_FAILURE';

export const FETCH_TERRITORY_LEADING_SILVER_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_LEADING_SILVER_AGENTS_REQUEST';
export const FETCH_TERRITORY_LEADING_SILVER_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_LEADING_SILVER_AGENTS_SUCCESS';
export const FETCH_TERRITORY_LEADING_SILVER_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_LEADING_SILVER_AGENTS_FAILURE';

export const FETCH_TERRITORY_LEADING_BRONZE_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_LEADING_BRONZE_AGENTS_REQUEST';
export const FETCH_TERRITORY_LEADING_BRONZE_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_LEADING_BRONZE_AGENTS_SUCCESS';
export const FETCH_TERRITORY_LEADING_BRONZE_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_LEADING_BRONZE_AGENTS_FAILURE';

export const FETCH_TERRITORY_MILKING_AGENTS_REQUEST =
  '@@map/FETCH_TERRITORY_MILKING_AGENTS_REQUEST';
export const FETCH_TERRITORY_MILKING_AGENTS_SUCCESS =
  '@@map/FETCH_TERRITORY_MILKING_AGENTS_SUCCESS';
export const FETCH_TERRITORY_MILKING_AGENTS_FAILURE =
  '@@map/FETCH_TERRITORY_MILKING_AGENTS_FAILURE';

export const fetch_snd_country_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/countries/${id}/?expand&rat`,
    method: 'GET',
    types: [
      FETCH_COUNTRY_SND_MAP_BY_ID_REQUEST,
      FETCH_COUNTRY_SND_MAP_BY_ID_SUCCESS,
      FETCH_COUNTRY_SND_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_snd_region_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/regions/${id}/?expand`,
    method: 'GET',
    types: [
      FETCH_SND_REGION_MAP_BY_ID_REQUEST,
      FETCH_SND_REGION_MAP_BY_ID_SUCCESS,
      FETCH_SND_REGION_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_snd_area_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/areas/${id}/?expand`,
    method: 'GET',
    types: [
      FETCH_SND_AREA_MAP_BY_ID_REQUEST,
      FETCH_SND_AREA_MAP_BY_ID_SUCCESS,
      FETCH_SND_AREA_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_snd_territory_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/territories/${id}/?expand`,
    method: 'GET',
    types: [
      FETCH_SND_TERRITORY_MAP_BY_ID_REQUEST,
      FETCH_SND_TERRITORY_MAP_BY_ID_SUCCESS,
      FETCH_SND_TERRITORY_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_distribution_house_summary_data = (selectedState, id) => ({
  [RSAA]: {
    endpoint: `/api/gis/distribution_houses/summary/?${selectedState}&id=${id}`,
    method: 'GET',
    types: [
      FETCH_DISTRIBUTION_HOUSE_SUMMARY_REQUEST,
      FETCH_DISTRIBUTION_HOUSE_SUMMARY_SUCCESS,
      FETCH_DISTRIBUTION_HOUSE_SUMMARY_FAILURE
    ]
  }
});

export const fetch_high_balance_agent_summary_data = (selectedState, id) => ({
  [RSAA]: {
    endpoint: `/api/gis/high_balance_agents/summary/?${selectedState}&id=${id}`,
    method: 'GET',
    types: [
      FETCH_HIGH_BALANCE_AGENT_SUMMARY_REQUEST,
      FETCH_HIGH_BALANCE_AGENT_SUMMARY_SUCCESS,
      FETCH_HIGH_BALANCE_AGENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_dh_stock_balance_lifting_summary_data = (
  selectedState,
  id
) => ({
  [RSAA]: {
    endpoint: `/api/gis/dh_stock_balance_liftings/summary/?${selectedState}&id=${id}`,
    method: 'GET',
    types: [
      FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_REQUEST,
      FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_SUCCESS,
      FETCH_DH_STOCK_BALANCE_LIFTING_SUMMARY_FAILURE
    ]
  }
});

export const fetch_dh_stock_progress_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/dh_stock_progress/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_DH_STOCK_PROGRESS_SUMMARY_REQUEST,
      FETCH_DH_STOCK_PROGRESS_SUMMARY_SUCCESS,
      FETCH_DH_STOCK_PROGRESS_SUMMARY_FAILURE
    ]
  }
});

export const fetch_dh_stock_balance_agent_summary_data = (
  selectedState,
  id
) => ({
  [RSAA]: {
    endpoint: `/api/gis/dh_stock_balance_agents/summary/?${selectedState}&id=${id}`,
    method: 'GET',
    types: [
      FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_REQUEST,
      FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_SUCCESS,
      FETCH_DH_STOCK_BALANCE_AGENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_agent_with_transaction_summary_data = (
  selectedState,
  id
) => ({
  [RSAA]: {
    endpoint: `/api/gis/agent_with_transactions/summary/?${selectedState}&id=${id}`,
    method: 'GET',
    types: [
      FETCH_AGENT_WITH_TRANSACTION_SUMMARY_REQUEST,
      FETCH_AGENT_WITH_TRANSACTION_SUMMARY_SUCCESS,
      FETCH_AGENT_WITH_TRANSACTION_SUMMARY_FAILURE
    ]
  }
});

export const fetch_leading_agent_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_LEADING_AGENT_SUMMARY_REQUEST,
      FETCH_LEADING_AGENT_SUMMARY_SUCCESS,
      FETCH_LEADING_AGENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_leading_agent_tpv_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents_tpv/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_LEADING_AGENT_TPV_SUMMARY_REQUEST,
      FETCH_LEADING_AGENT_TPV_SUMMARY_SUCCESS,
      FETCH_LEADING_AGENT_TPV_SUMMARY_FAILURE
    ]
  }
});

export const fetch_leading_agent_category_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents_categories/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_LEADING_AGENT_CATEGORY_SUMMARY_REQUEST,
      FETCH_LEADING_AGENT_CATEGORY_SUMMARY_SUCCESS,
      FETCH_LEADING_AGENT_CATEGORY_SUMMARY_FAILURE
    ]
  }
});

export const fetch_milking_agent_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/milking_agents/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_MILKING_AGENT_SUMMARY_REQUEST,
      FETCH_MILKING_AGENT_SUMMARY_SUCCESS,
      FETCH_MILKING_AGENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_active_agent_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/active_agents/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_ACTIVE_AGENT_SUMMARY_REQUEST,
      FETCH_ACTIVE_AGENT_SUMMARY_SUCCESS,
      FETCH_ACTIVE_AGENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_active_agent_without_disbursement_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/active_agents_without_disbursement/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_REQUEST,
      FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_SUCCESS,
      FETCH_ACTIVE_AGENT_WITHOUT_DISBURSEMENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_active_agent_partner_payment_only_summary_data = (
  selectedState,
  id,
  type,
  date
) => ({
  [RSAA]: {
    endpoint: `/api/gis/active_agents_partner_payment/summary/?${selectedState}&id=${id}&date=${date}&type=${type}`,
    method: 'GET',
    types: [
      FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_REQUEST,
      FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_SUCCESS,
      FETCH_ACTIVE_AGENT_PARTNER_PAYMENT_SUMMARY_FAILURE
    ]
  }
});

export const fetch_territory_distribution_houses = (id, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/distribution_houses/all/?${filter}=${id}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_DISTRIBUTION_HOUSES_REQUEST,
      FETCH_TERRITORY_DISTRIBUTION_HOUSES_SUCCESS,
      FETCH_TERRITORY_DISTRIBUTION_HOUSES_FAILURE
    ]
  }
});

export const fetch_territory_high_balance_agents = (id, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/high_balance_agents/all/?distribution_house__${filter}=${id}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_HIGH_BALANCE_AGENTS_REQUEST,
      FETCH_TERRITORY_HIGH_BALANCE_AGENTS_SUCCESS,
      FETCH_TERRITORY_HIGH_BALANCE_AGENTS_FAILURE
    ]
  }
});

export const fetch_territory_dh_stock_balance_liftings = (id, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/dh_stock_balance_liftings/all/?${filter}=${id}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_REQUEST,
      FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_SUCCESS,
      FETCH_TERRITORY_DH_STOCK_BALANCE_LIFTINGS_FAILURE
    ]
  }
});

export const fetch_territory_dh_stock_progress = (id, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/dh_stock_progress/all/?${filter}=${id}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_DH_STOCK_PROGRESS_REQUEST,
      FETCH_TERRITORY_DH_STOCK_PROGRESS_SUCCESS,
      FETCH_TERRITORY_DH_STOCK_PROGRESS_FAILURE
    ]
  }
});

export const fetch_territory_dh_stock_balance_agents = (id, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/dh_stock_balance_agents/all/?${filter}=${id}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_REQUEST,
      FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_SUCCESS,
      FETCH_TERRITORY_DH_STOCK_BALANCE_AGENT_FAILURE
    ]
  }
});

export const fetch_territory_active_agents = (id, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/active_agents/all/?distribution_house__${filter}=${id}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_ACTIVE_AGENTS_REQUEST,
      FETCH_TERRITORY_ACTIVE_AGENTS_SUCCESS,
      FETCH_TERRITORY_ACTIVE_AGENTS_FAILURE
    ]
  }
});

export const fetch_territory_active_agents_without_disbursement = (
  id,
  date,
  filter
) => ({
  [RSAA]: {
    endpoint: `/api/gis/active_agents_without_disbursement/all/?distribution_house__${filter}=${id}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_REQUEST,
      FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_SUCCESS,
      FETCH_TERRITORY_ACTIVE_AGENTS_WITHOUT_DISBURSEMENT_FAILURE
    ]
  }
});

export const fetch_territory_active_agents_partner_payment = (
  id,
  date,
  filter
) => ({
  [RSAA]: {
    endpoint: `/api/gis/active_agents_partner_payment/all/?distribution_house__${filter}=${id}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_REQUEST,
      FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_SUCCESS,
      FETCH_TERRITORY_ACTIVE_AGENTS_PARTNER_PAYMENT_FAILURE
    ]
  }
});

export const fetch_territory_agents_with_transaction = (id, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/agent_with_transactions/all/?distribution_house__${filter}=${id}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_REQUEST,
      FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_SUCCESS,
      FETCH_TERRITORY_AGENTS_WITH_TRANSACTION_FAILURE
    ]
  }
});

export const fetch_territory_leading_agents = (id, type, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents/all/?distribution_house__${filter}=${id}&type=${type}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_LEADING_AGENTS_REQUEST,
      FETCH_TERRITORY_LEADING_AGENTS_SUCCESS,
      FETCH_TERRITORY_LEADING_AGENTS_FAILURE
    ]
  }
});

export const fetch_territory_leading_agents_tpv = (id, type, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents_tpv/all/?distribution_house__${filter}=${id}&type=${type}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_LEADING_AGENTS_TPV_REQUEST,
      FETCH_TERRITORY_LEADING_AGENTS_TPV_SUCCESS,
      FETCH_TERRITORY_LEADING_AGENTS_TPV_FAILURE
    ]
  }
});

export const fetch_territory_gold_agents = (id, type, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents_categories/gold_agents/?distribution_house__${filter}=${id}&type=${type}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_LEADING_GOLD_AGENTS_REQUEST,
      FETCH_TERRITORY_LEADING_GOLD_AGENTS_SUCCESS,
      FETCH_TERRITORY_LEADING_GOLD_AGENTS_FAILURE
    ]
  }
});

export const fetch_territory_silver_agents = (id, type, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents_categories/silver_agents/?distribution_house__${filter}=${id}&type=${type}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_LEADING_SILVER_AGENTS_REQUEST,
      FETCH_TERRITORY_LEADING_SILVER_AGENTS_SUCCESS,
      FETCH_TERRITORY_LEADING_SILVER_AGENTS_FAILURE
    ]
  }
});

export const fetch_territory_bronze_agents = (id, type, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/leading_agents_categories/bronze_agents/?distribution_house__${filter}=${id}&type=${type}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_LEADING_BRONZE_AGENTS_REQUEST,
      FETCH_TERRITORY_LEADING_BRONZE_AGENTS_SUCCESS,
      FETCH_TERRITORY_LEADING_BRONZE_AGENTS_FAILURE
    ]
  }
});

export const fetch_territory_milking_agents = (id, type, date, filter) => ({
  [RSAA]: {
    endpoint: `/api/gis/milking_agents/all/?distribution_house__${filter}=${id}&type=${type}&date=${date}`,
    method: 'GET',
    types: [
      FETCH_TERRITORY_MILKING_AGENTS_REQUEST,
      FETCH_TERRITORY_MILKING_AGENTS_SUCCESS,
      FETCH_TERRITORY_MILKING_AGENTS_FAILURE
    ]
  }
});
